// src/components/IncomingOrders/hooks/useCellSx.js

import { useMemo } from "react";
import { useTheme, alpha } from "@mui/material/styles";

const buildCellStyles = ({ type, dirty, theme }) => {
  const dirtyBase = {
    backgroundColor: alpha(theme.palette.warning.main, 0.12),  // "rgba(255, 193, 7, 0.12)", // mjuk gul ton
    boxShadow: "inset 3px 0 0 #f7bd02",  // TODO: color
    transition: "background-color 150ms ease",
  };

  // ----- Type-specific tweaks --------------------------------------------------

  if (type === "date") {
    return {
      ...(dirty && { ...dirtyBase }),

      "& .react-datepicker__input-container input": {
        ...({
          width: "7em",
          fontSize: "inherit",
          p: 0.5,
          backgroundColor: "transparent",
          borderColor: "rgba(0, 0, 0, 0.23)",  // TODO: color [ alpha(theme.palette.divider, 0.23) ? ]
          borderRadius: 1,
          borderWidth: "1px",
        }),

        ...(dirty && {
          //fontWeight: 600,
        }),
      },
    };
  }

  if (type === "select") {
    return {
      ...(dirty && { ...dirtyBase }),

      "& .MuiOutlinedInput-root": {
        backgroundColor: "transparent",
        fontSize: "inherit",
        minWidth: 140,

        "& .MuiOutlinedInput-input": {
          padding: "4px 6px",
        },
        "& fieldset": {
          borderColor: "rgba(0,0,0,0.08)",
        },
        "&:hover": {
          backgroundColor: theme.palette.background.paper,
        },
        "&:hover fieldset": {
          borderColor: "rgba(0,0,0,0.20)",
        },
        "&.Mui-focused": {
          backgroundColor: theme.palette.background.paper,
        },
        "&.Mui-focused fieldset": {
          borderColor: "rgba(0,0,0,0.30)",
        },

        ...(dirty && {
          //fontWeight: 600,
        }),
      },
    };
  }

  return {};
};

const useCellSx = ({ isFieldDirty }) => {
  const theme = useTheme();

  return useMemo(
    () => ({ fieldName, rowId, type }) => {
      const dirty = isFieldDirty(fieldName, { rowId });

      return buildCellStyles({ dirty, type, theme });
    },
    [isFieldDirty, theme]
  );
};

export default useCellSx;
